module.exports = __webpack_public_path__ + "media/img/footer/footer-bg-b56460cf70afb77af4ffb6b91b7f83b4.webp";